import styled from 'styled-components'
import { lightGray, mildGray } from '../../../../styles/variables.js'

const IngredientDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1;
  padding: 10px
  padding-bottom: 80px;
  margin-left: 30px;
`

const IngredientDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div:first-child {
    margin-right: 20px;
  }

  & > .descriptionInput {
    min-width: 100%;
  }
`

const Serving = styled.div`
  box-sizing: border-box;
  text-align: center;
  padding: 10px 10px !important;
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  height: 40px;
  outline: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;

  background: none;
  border: 2px solid ${lightGray};
  color: ${lightGray};

  &.selected {
    background: ${lightGray};
    border: 2px solid ${lightGray};
    color: white;
  }

  &.disabled {
    opacity: 0.5;
  }

  &.error {
    border: 2px solid red;
  }
`

const ServingRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  &.first {
    align-items: center;
  }

  & > div {
    margin-right: 20px;
    padding-top: 0;
    padding-bottom: 15px;
    max-width: 170px;
    min-width: 170px;
  }
`

const Label = styled.div`
  font-size: 14px;
  color: ${mildGray};
  margin-bottom: 15px;
`

const Refresh = styled.div`
  cursor: pointer;
  transition: all .1s ease-in-out;
  color: ${mildGray};
  padding: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  display: inline-block;
  font-size: 20px;

  &:hover {
    transform: scale(1.1);
    color: black;
  }

  &.locked {
    opacity: 0.7;
    cursor: default;
    &:hover {
      transform: none;
      color: ${mildGray};
    }
  }
`

const Placeholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const IngredientDescriptionBlock = styled.div`
  flex: 1 1;
`

const IngredientQuantityBlock = styled.div`
  margin-left: 30px;
`

const IngredientQuantityBlockPlaceholder = styled.div`
  width: 440px;
  margin-left: 30px;
`

export default {
  Serving,
  IngredientDetails,
  IngredientDetailsRow,
  Label,
  ServingRow,
  Refresh,
  Placeholder,
  IngredientDescriptionBlock,
  IngredientQuantityBlock,
  IngredientQuantityBlockPlaceholder,
}
